export default {
    book: "書{product}",
    age_limit: "超過{age}的唯一",
    change_plan: "改變計劃",
    upgrade_product: "升級產品",
    upgrade: "升級",
    cancel_upgrade: "取消升級",
    choose_product: "選擇{product}",
    days: "{count}天| {count} 天",
    login_register: "登入/註冊",
    current: "目前的",
    keyless_benefits: {
        label: '直接上車{0}',
        highlight: '租賃服務™',
        list: {
            cant_lose_the_key: '全額保險',
            zero_excess: '零過剩',
            phone_as_a_key: '電話作為鑰匙',
            straight_to_car: '無需等待',
            no_queues: '無需排隊',
            online_id_check: '網路身分證查詢',
            self_checkout: '自助退房',
        },
    },
}
